import React from 'react';
import styles from './BookingModal.module.css';

const BookingModal = ({ onClose }) => {
    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onClose}>×</button>
                <iframe
                    src="https://outlook.office365.com/book/DiwaliFinancialWellnessSession@fabits.com/"
                    title="Booking Page"
                    className={styles.iframe}
                />
            </div>
        </div>
    );
};

export default BookingModal;
